import { isServerSide } from "#src/util/helpers.js";
import { defineStore as definePiniaStore } from "pinia";

export const defineStore = (id, state) => {
  return (pinia, hot) => {
    if (!pinia && isServerSide()) throw new Error("Pinia instance is required");
    return definePiniaStore(id, state)(pinia, hot);
  };
};
